import React from 'react';
import { useControlService } from '../../common/atomic/hooks';
import { ShadowControls } from './ShadowControls';

import { STYLE } from '@wix/component-protocol/schema';
import { getValidStyleIds } from '../../common/valueResolverService';

export const ShadowControlsGuard: React.FC = () => {
  const service = useControlService();
  const validStyleIds = getValidStyleIds(
    service.styles,
    service.styleDefinitions,
    [STYLE.CSS_PROPERTY_TYPE.boxShadow],
  );
  if (validStyleIds.length === 0) {
    return null;
  }
  return <ShadowControls service={service} styleIds={validStyleIds} />;
};
